import { fetchFalckdkApi } from '../utils/fetch';

const ErrorCssClass = 'show-error';
const ZipCodeLength = 4;

function createHtmlElemSelectors() {
    return {
        htmlElements: {
            companyAutosuggestionInput: document.getElementById('company-autosuggestion-search'),
            companySuggestionsList: document.getElementById('company-autosuggestion-results'),
            companyInput: document.getElementById('company'),
            companyValue: document.getElementById('company-value'),
            cityInput: document.getElementById('city'),
            addressLine1Input: document.getElementById('addressLine1'),
            addressLine2Input: document.getElementById('addressLine2'),
            postalCodeInput: document.getElementById('postalCode'),
            dunsInput: document.getElementById('duns'),
            spinner: document.getElementById('overlay'),
            zipcodeInput: document.getElementById('zipcode-autosuggestion-search'),
        },
    };
}

const Validation = {
    setupFocusOutValidation(inputElement, test) {
        inputElement.addEventListener('focusout', (e) => {
            const testValue = test(e);
            const { parentElement } = inputElement;
            const parentElHasError = parentElement.classList.contains(ErrorCssClass);

            if (!testValue && !parentElHasError) {
                parentElement.classList.add(ErrorCssClass);
            } else if (testValue && parentElHasError) {
                parentElement.classList.remove(ErrorCssClass);
            }
        });
    },
    tests: {
        zipInput: (e) => e.target.value.trim().length === ZipCodeLength,
    },
};

function getStreetWithNumberArr(addressLine1) {
    if (!addressLine1?.length) {
        return [];
    }
    const items = addressLine1.split(',');

    return items[0].split(' ');
}

function getStreet(addressLine1) {
    const streetArrWithOutNumber = getStreetWithNumberArr(addressLine1).slice(0, -1);

    return streetArrWithOutNumber.join(' ').trim();
}

function getStreetNumber(addressLine1) {
    return getStreetWithNumberArr(addressLine1).pop();
}

export function initCompanyAutosuggestion() {
    const { htmlElements } = createHtmlElemSelectors();
    const dnbApiUrl = '/api/dnb/searchcompany';

    Validation.setupFocusOutValidation(htmlElements.zipcodeInput, Validation.tests.zipInput);

    htmlElements.zipcodeInput.addEventListener('input', (e) => {
        if (e.target.value.trim()?.length >= ZipCodeLength) {
            htmlElements.companyAutosuggestionInput.removeAttribute('disabled');
        } else {
            htmlElements.companyAutosuggestionInput.setAttribute('disabled', 'disabled');
        }
    });

    const requestCompanyData = async (searchTerm) => {
        const response = await fetchFalckdkApi(dnbApiUrl, {
            params: {
                query: searchTerm,
                postalCode: htmlElements.zipcodeInput.value,
            },
        });

        try {
            return await response.json();
        } catch {
            alert('could not fetch the data');
            hideSpinner();
        }
    };

    function debounce(func, timeout = 300) {
        let timer;

        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    const createCompanySuggestionElement = (company) => {
        const companyResultEl = document.createElement('button');

        companyResultEl.classList.add('company-suggestion-item');
        companyResultEl.textContent = company.Name;

        companyResultEl.addEventListener('click', (e) => {
            e.preventDefault();
            htmlElements.companyAutosuggestionInput.value = company.Name;

            populateFields(company);
            clearCompanyResults();
        });

        htmlElements.companySuggestionsList.appendChild(companyResultEl);
    };

    const companyInputListener = debounce(async (event) => {
        clearCompanyResults();

        const companyName = event.target.value;

        showSpinner();

        const companiesData = await requestCompanyData(companyName);

        companiesData.forEach(createCompanySuggestionElement);

        hideSpinner();
    });

    function clearCompanyResults() {
        htmlElements.companySuggestionsList.replaceChildren();
    }

    function showSpinner() {
        htmlElements.spinner.classList.add('show');
    }

    function hideSpinner() {
        htmlElements.spinner.classList.remove('show');
    }

    const populateFields = (company) => {
        htmlElements.companyValue.value = JSON.stringify({
            ...company,
            street: getStreet(company.AddressLine1),
            streetNumber: getStreetNumber(company.AddressLine1),
            duns: company.DunsNo,
        });
        htmlElements.companyInput.value = company.Name;
        htmlElements.addressLine1Input.value = company.AddressLine1;
        htmlElements.addressLine2Input.value = company.AddressLine2;
        htmlElements.cityInput.value = company.City;
        htmlElements.dunsInput.value = company.DunsNo;
        htmlElements.postalCodeInput.value = company.ZipCode;
    };

    htmlElements.companyAutosuggestionInput.addEventListener('input', companyInputListener);
}
